import { render } from "./warehouseman.vue?vue&type=template&id=1d3c6cd0&scoped=true"
import script from "./warehouseman.vue?vue&type=script&lang=js"
export * from "./warehouseman.vue?vue&type=script&lang=js"

import "./warehouseman.vue?vue&type=style&index=0&id=1d3c6cd0&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3c6cd0"]])

export default __exports__